require('./okDiscountView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');

// @core
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @utilities
const { getOriginCountry } = require('utilities/countryHelper');
const { decodeHTMLEntities } = require('utilities/stringHelper');

// @actions
const OkDiscountsActions = require('actions/okDiscounts');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @components
const OkDiscountModal = require('components/okDiscount/okDiscountModal/okDiscountModal');
const OkDiscountBody = require('components/okDiscount/okDiscountBody/okDiscountBody');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @constants
const { OKDISCOUNT_STATUS_ALREADY_ADDED } = require('constants/index');


class OkDiscountView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
    }

    componentDidMount() {
        const {
            requestDiscountDetailsPercentage,
            getUserStatus,
            requestDiscountDetail,
            match: { params: { categoryId, discountId } }
        } = this.props;

        getUserStatus();
        requestDiscountDetail(discountId, categoryId);
        requestDiscountDetailsPercentage(discountId, categoryId);
    }

    buildHeader() {
        const { immOkDiscount, immProfile, immGlobalVariables } = this.props;
        const okDiscountDetail = immOkDiscount.get('okDiscountDetail');

        const promotionName = okDiscountDetail.getIn(['discount', 'promotionName']);
        const backgroundUrlImage = okDiscountDetail.getIn(['header', 'background', 'url']);
        const promotionCategoryPath = okDiscountDetail.getIn(['discount', 'categoryPath']);
        const country = getOriginCountry(immProfile.get('originCountry'));
        const publicSiteUrl = getPublicSiteUrl(country);

        // Promotions url
        const publicPromotionsPath = immGlobalVariables.getIn(['variables', 'parameters', 'public_urls', 'promotions']);
        const publicPromotionsLink = `${publicSiteUrl}${publicPromotionsPath}`;

        // Discounts url
        const publicDiscountPath = immGlobalVariables.getIn(['variables', 'parameters', 'public_urls', 'discounts']);
        const publicDiscountLink = `${publicSiteUrl}${publicDiscountPath}`;
        const publicCategoryLink = `${publicDiscountLink}/${promotionCategoryPath}`;

        let breadcrumbTitle = okDiscountDetail.getIn(['discount', 'breadcrumbTitle']);
        if (!breadcrumbTitle) {
            breadcrumbTitle = okDiscountDetail.getIn(['discount', 'title']);
        }
        if (!!breadcrumbTitle) {
            breadcrumbTitle = decodeHTMLEntities(breadcrumbTitle);
            if (breadcrumbTitle.length > 30) {
                breadcrumbTitle = breadcrumbTitle.substr(0, 30) + '...';
            }
        }

        const mappingBreadcrumb = [
            {
                text: formatText('OKDiscounts-breadcrumbPromotions'),
                url: publicPromotionsLink
            },
            {
                text: formatText('OKDiscounts-breadcrumbDiscounts'),
                url: publicDiscountLink
            },
            {
                text: promotionName,
                url: publicCategoryLink
            },
            {
                text: breadcrumbTitle
            }
        ];


        return (
            <OKCover
                size="medium"
                section="custom"
                backgroundUrlImage={backgroundUrlImage}>
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                >
                </OKHeaderSubPage>
            </OKCover>
        )
    }

    handleGoBack() {
        this.props.history.goBack();
    }

    handleRegister() {
        const { register } = this.props;
        register();
    }

    render() {
        const {
            immFlagBasedFeatures,
            immOkDiscount,
            requestExternalCode,
            requestReferralPromotionDiscount,
            immGlobalVariables,
            immProfile
        } = this.props;

        const inProgress = immOkDiscount.get('inProgress');
        const error = immOkDiscount.get('error');
        const immErrorList = immOkDiscount.get('errorList');
        const okDiscountDetail = immOkDiscount.get('okDiscountDetail');
        const isLoading = okDiscountDetail.get('isLoading');
        const submitSuccessful = immOkDiscount.get('submitSuccessful');
        const errorReceived = immOkDiscount.get('errorReceived');
        const userDiscountStatus = immOkDiscount.get('userDiscountStatus') || '';
        const promotionCategoryPath = okDiscountDetail.getIn(['discount', 'categoryPath']);
        const isOpen = !!userDiscountStatus && userDiscountStatus !== OKDISCOUNT_STATUS_ALREADY_ADDED && (error || !submitSuccessful);
        const country = getOriginCountry(immProfile.get('originCountry'));

        const discountHeader = this.buildHeader();
        let content = null;

        if (!errorReceived) {
            content = (
                <div className="ok-discount-view">
                    <OkDiscountModal
                        onRegister={this.handleRegister}
                        inProgress={inProgress}
                        error={error}
                        immErrorList={immErrorList}
                        submitSuccessful={submitSuccessful}
                        userDiscountStatus={userDiscountStatus}
                        isOpen={isOpen}
                        promotionCategoryPath={promotionCategoryPath}
                        immGlobalVariables={immGlobalVariables}
                        immProfile={immProfile}
                    />
                    {discountHeader}
                    <OkDiscountBody
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        immGlobalVariables={immGlobalVariables}
                        immOkDiscount={immOkDiscount}
                        requestReferralPromotionDiscount={requestReferralPromotionDiscount}
                        isLoading={isLoading}
                        inProgress={inProgress}
                        isModalOpen={isOpen}
                        requestExternalCode={requestExternalCode}
                        userDiscountStatus={userDiscountStatus}
                        country={country}
                    />
                </div>
            )
        } else {
            const backButton = (
                <OKButton onClick={() => this.handleGoBack()}>
                    <FormattedText value="buttonsActions-goBack" />
                </OKButton>
            );

            content = (
                <div className="ok-discount-view">
                    <OKSectionBox>
                        <EmptyState
                            primaryText={<FormattedText value="OKDiscounts-errorMessage" />}
                            button={backButton}
                            iconType="nointernet-banking"
                        />
                    </OKSectionBox>
                </div>
            )
        }
        return content;
    }
}

OkDiscountView.propTypes = {
    history: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immOkDiscount: PropTypes.object,
    immGlobalVariables: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    requestDiscountDetail: PropTypes.func.isRequired,
    requestDiscountDetailsPercentage: PropTypes.func.isRequired,
    requestReferralPromotionDiscount: PropTypes.func.isRequired,
    getUserStatus: PropTypes.func.isRequired,
    register: PropTypes.func,
    requestExternalCode: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports.constructor = OkDiscountView;

module.exports.OkDiscountView = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immOkDiscount: state.okDiscounts,
        immGlobalVariables: state.globalVariables,
        immProfile: state.profile,
    }),
    {
        getUserStatus: OkDiscountsActions.getUserStatus,
        requestReferralPromotionDiscount: OkDiscountsActions.requestReferralPromotionDiscount,
        register: OkDiscountsActions.register,
        requestDiscountDetail: OkDiscountsActions.requestDiscountDetail,
        requestDiscountDetailsPercentage: OkDiscountsActions.requestDiscountDetailsPercentage,
        requestExternalCode: OkDiscountsActions.requestExternalCode
    }
)(withRouter(OkDiscountView));
